/**
 * Code -> description maps shared by the reference lookups that label the codes
 * on a printed document (billing modifiers, ICD-10 diagnoses).
 *
 * Super Bill lines and note codes persist bare codes ("25", "M79.10"), so every
 * surface that needs to *label* one resolves it through a map like this rather
 * than storing the description alongside the code — the descriptions are
 * reference data, not per-bill data.
 */
export type CodeDescriptionMap = Record<string, string>;

/**
 * Distinct, upper-cased, blank-free codes in a stable sorted order.
 *
 * Sorted and de-duplicated because the result doubles as a React Query cache
 * key: reordering service lines, or the same code appearing on two lines, must
 * not produce a different key and refetch the same lookup.
 */
export const normalizeCodes = (codes: readonly string[]): string[] => {
  const unique = new Set<string>();
  for (const raw of codes) {
    const code = (raw ?? "").trim().toUpperCase();
    if (code) unique.add(code);
  }
  return Array.from(unique).sort();
};
